<ng-template cdkConnectedOverlay [cdkConnectedOverlayPositionStrategy]="globalOverlay" [cdkConnectedOverlayOpen]="true">
  <div class="inactivity-warning-overlay" [class.digital-signage-on]="digitalSignageOn()">
    <button cue-button class="inactivity-warning" [link]="true" variant="secondary">
      {{ translation.navigation.resetAfter | transloco }} {{ countdown() }}s
      <cue-icon [icon]="ICONS.cueClose" />
    </button>
  </div>
</ng-template>
